import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrandCampaignListComponent } from './brand-campaign-list/brand-campaign-list.component';
import { CampaignListModule } from '../campaigns/campaign-list/campaign-list.module';
import { AppCommonModule } from 'src/app/common/common.module';
import { BrandListComponent } from './brand-list/brand-list.component';
import { CompanyListModule } from '../companies/company-list/company-list.module';

const components = [
  BrandCampaignListComponent,
  BrandListComponent
];

@NgModule({
  declarations: components,
  imports: [
    AppCommonModule,
    CampaignListModule,
    CommonModule,
    CompanyListModule
  ],
  exports: components
})
export class AdvertisersModule { }
